<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-subtitle-1 mr-4"><v-icon>mdi-cash-multiple</v-icon>Transacciones Online</span>

            <!-- Inputs de búsqueda / fechas -->
            <v-text-field
              v-model="fechaInicio"
              label="Fecha inicio"
              type="date"
              dense
              hide-details
              outlined
              class="me-2"
            ></v-text-field>

            <v-text-field
              v-model="fechaFinal"
              label="Fecha final"
              type="date"
              dense
              hide-details
              outlined
              class="me-2"
            ></v-text-field>

            <v-spacer></v-spacer>

            <!-- Boton para descargar el excel -->
            <v-btn
              class="mr-2"
              small
              dark
              color="green"
              @click="exportExcel(transacciones, 'transacciones-online')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn color="primary" small rounded tile @click="buscarTransacciones">
              <v-icon small>mdi-refresh</v-icon> Buscar
            </v-btn>
          </v-card-title>

          <v-card-text>
            <!-- Selector de Base de Datos -->
            <v-radio-group v-model="escuela" row dense small class="mb-4">
              <v-radio label="INBI" :value="0"></v-radio>
              <v-radio label="FAST" :value="2"></v-radio>
            </v-radio-group>

            <!-- Tabla -->
            <v-data-table
              :headers="headers"
              :items="transacciones"
              dense
              class="elevation-0"
            >
              <template v-slot:no-data>
                <v-btn color="primary" @click="buscarTransacciones" small rounded>
                  Actualizar
                </v-btn>
              </template>
            </v-data-table>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />

  </v-container>
</template>

<script>
import axios from "axios";

// Componentes
import Alerta from "@/components/alertas/Alerta.vue";
import carga from "@/components/alertas/carga.vue";

import validarErrores from "@/mixins/validarErrores";
import funcionesExcel from "@/mixins/funcionesExcel";

export default {

  components: {
    Alerta,
    carga,
  },

  data: () => ({

    // Alertas
    parametros: {
      dialogError: false,
      mensaje: "",
      color: "",
    },

    respuestaAlerta: false,
    loader: true,
    cargar: false,

    escuela: 0,
    fechaInicio: "",
    fechaFinal: "",
    transacciones: [],
    headers: [
      { text: "ID", value: "id" },
      { text: "Folio", value: "bnrg_folio" },
      { text: "Texto", value: "bnrg_texto" },
      { text: "Tipo Cuenta", value: "bnrg_tipo_cuenta" },
      { text: "Marca Tarjeta", value: "bnrg_marca_tarjeta" },
      { text: "Referencia", value: "bnrg_referencia" },
      { text: "Fecha Registro", value: "fecha_registro" },
      { text: "Monto", value: "bnrg_monto_trans" }
    ]

  }),

  mixins: [validarErrores, funcionesExcel],

  created() {
    const hoy = new Date();
    this.fechaInicio = hoy.toISOString().slice(0, 10);
    this.fechaFinal = hoy.toISOString().slice(0, 10);
  },

  methods: {
    async buscarTransacciones() {

      this.transacciones = []
      try {
        const res = await axios.get('transacciones.online', {
          params: {
            escuela: this.escuela,
            fecha_inicio: this.fechaInicio,
            fecha_final: this.fechaFinal
          }
        });
        this.transacciones = res.data;
      } catch (error) {
        console.error(error);
        this.$toast.error("Error al obtener transacciones");
      }
    },
  }
};
</script>

<style scoped>
</style>
